import React from 'react';

const SingleStatistic = props => {
    return (
        <tr>
            <td>{props.data.name}</td>
            <td></td>
            <td>{props.data.pendingOrdersCount}</td>
            <td></td>
            <td>{props.data.activeOrdersCount}</td>
            <td></td>
            <td>{props.data.readyOrdersCount}</td>
            <td></td>
            <td>{props.data.cancelledOrdersCount}</td>
            <td></td>
            <td>{props.data.orderCount}</td>
            <td></td>
            <td>30 min</td>
        </tr>
    );
};

export default SingleStatistic;


// WEBPACK FOOTER //
// ./src/customModules/Statistics/components/Single-statistic.js